module.exports = __webpack_public_path__ + "staticcomp/img/marquee.794ea1e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/3/1/marquee.jpg
// module id = v1os
// module chunks = 39